<template>
  <div>
    <router-view v-if="init" />
  </div>
</template>

<script>
  import {mapGetters, mapState, mapMutations, mapActions} from "vuex";

  export default {
    name: "Partner",
    data(){
      return {
        init: false,
      }
    },
    computed: {
      ...mapGetters('users',['userCan']),
      ...mapState('users', ['permissions','currentUser']),
    },
    created() {
      if(this.currentUser.user_type === 'Partner'){
        this.SET_PARTNER_NAMESPACE(this.currentUser.partner);
        this.addDefaultHeader({key: 'X-PARTNER-ID', value: this.currentUser.partner});
        this.$vs.loading({type:'point'});
        this.getPartnerZones({partner_id: this.currentUser.partner, limit: 10000})
          .then(data=>{
            if(this.$route.query.zone_id){
              let isZoneValid = false;
              for(let item of data.zones){
                if(item.id === this.$route.query.zone_id){
                  isZoneValid = true;
                  break;
                }
              }
              if(isZoneValid === false){
                this.$router.push({name:'root'});
              }
            }

            this.init = true;
            this.$vs.loading.close();
          })
          .catch(error =>{
            this.$vs.loading.close();

                    this.$vs.notify({
                      color: "danger",
                      title: `Error`,
                      text: "There was an error. Please try again later."
                    });
          })

        this.getConfig({}).then(data=>{

        }).catch(error =>{

        })
      }else{
        this.SET_PARTNER_NAMESPACE(null);
        this.$router.push({name:'root'});
      }
    },
    methods: {
      ...mapMutations(['SET_PARTNER_NAMESPACE']),
      ...mapActions('zones',['getPartnerZones']),
      ...mapActions(['addDefaultHeader']),
      ...mapActions('partners',['getConfig'])
    }
  }
</script>

<style scoped>

</style>
